import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { StringUtils } from '@/common/utils/StringUtils';
import { Link, useTheme } from '@mui/material';
// TODO!! this could likely be simplified
export const PriceResTierCellRenderer = ({ node, value, colDef }) => {
  const { navigateTo } = useNavState();
  const { hist } = useEntityMgr();
  const theme = useTheme();

  const navigate = async (openNewTab) => {
    const idField = colDef.idField ?? 'id';

    const entityId = node.data[idField];

    let entity = colDef.entity ?? node.data.entity; // node.data.entity for cases where components hyperlink to foreign entities by entity and entityId (e.g. ValList)

    const route = colDef.module + '/' + StringUtils.toKebabConvention(entity);

    // Calculating As Of Date
    const now = new Date();
    const verStartInstant = new Date(node.data.verStartInstant);
    const verEndInstant = new Date(node.data.verEndInstant);

    const currentRecord = verStartInstant < now && now < verEndInstant;

    const asOfDate = hist && !currentRecord ? node.data.verEndInstant : null;

    const navState = {
      entityId: entityId,
      mode: Mode.DETAIL,
      asOfDate: asOfDate,
    };

    navigateTo(route, navState, openNewTab);
  };

  // Pinned rows (e.g. a totals row) are not Entities, so there is nothing to navigate to
  if (node.rowPinned) {
    return value;
  }

  return (
    <Link
      onClick={(event) => navigate(event.ctrlKey)}
      sx={{
        cursor: 'pointer',
        color: theme.palette.primary.dark,
      }}
    >
      {value}
    </Link>
  );
};
